import React from "react";

// Shared lead-form consent copy. Verbatim as required by Phase 6A compliance.
export const LEAD_CONSENT_TEXT =
  "By submitting this form, you consent that a licensed insurance producer may contact you by phone, email, or text at the information you provided regarding insurance products and services. Consent is not a condition of purchase.";

export const PHONE_TCPA_TEXT =
  "Standard call/text rates may apply. You may opt out at any time.";

export const ConsentMicrocopy = ({ withPhone = false, className = "" }) => (
  <div
    data-testid="consent-microcopy"
    className={`text-[11px] text-lw-muted leading-relaxed ${className}`}
  >
    <p data-testid="consent-lead">{LEAD_CONSENT_TEXT}</p>
    {withPhone && (
      <p data-testid="consent-tcpa" className="mt-1">
        {PHONE_TCPA_TEXT}
      </p>
    )}
  </div>
);

export default ConsentMicrocopy;
